import { render, staticRenderFns } from "./MailRecuperarPassword.vue?vue&type=template&id=66bfbeb1&"
import script from "./MailRecuperarPassword.vue?vue&type=script&lang=js&"
export * from "./MailRecuperarPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports